<template>
  <div id="modal-info-body">
    <h2 style="text-align: center">Cadastre-se</h2>
    <p>
      Para ter acesso ao sistema de Monitoramento e Avaliação na APS (M & A na
      APS), você deve criar uma conta em LOGIN >>
      <a href="https://site.esusfeedback.com.br/criar-conta" target="_blank"
        >Criar conta</a
      >. o sistema está organizado com funções de acordo o seu perfil
      profissional no município.
    </p>
    <br />
    <p>
      O fluxo para um novo usuário ter acesso ao sistema e realizar seu M & A na
      APS é assim:
    </p>
    <ul style="list-style: decimal;">
      <li>
        O profissional de saúde vai em LOGIN >>
        <a href="https://site.esusfeedback.com.br/criar-conta" target="_blank"
          >Criar conta</a
        >, preenche o formulário e comunica a gestão municipal;
      </li>
      <li>
        A representação da gestão municipal (Administrador(a) municipal do e-SUS
        PEC ou Centralizador, Coordenador(a) ou Secretário(a)) vai em
        <strong>INÍCIO >> Administração >> Gerenciar usuários</strong>, busca o
        usuário que ainda está inativo e ativa o acesso;
      </li>
      <li>
        O usuário entra com CPF e SENHA e consegue visualizar as informações dos
        cidadãos de acordo com sua lotação na APS municipal.
      </li>
    </ul>
    <p>Interpreta-se os campos do formulário para criar uma conta assim:</p>
    <ul>
      <li>
        <strong>ESTADO</strong> – Sigla do estado onde está localizado o
        município que você trabalha;
      </li>
      <li>
        <strong>CIDADE DE TRABALHO</strong> – nome da cidade onde você
        atualmente trabalha. Somente está disponível após a escolha do ESTADO;
      </li>
      <li><strong>CPF </strong> – seu número de CPF;</li>
      <li>
        <strong>PERFIL</strong> – função em que você atua no município escolhido
        na CIDADE DE TRABALHO;
      </li>
      <li><strong>Data de nascimento</strong> – a data em que você nasceu;</li>
      <li>
        <strong>E-MAIL</strong> – seu principal e-mail. Ele é utilizado para
        redefinir senha, quando precisar;
      </li>
      <li>
        <strong>TELEFONE</strong> – seu número de telefone ou WhatApp, ele é
        utilizado para envio de mensagem com redefinição de senha ou notificação
        de segurança da sua conta;
      </li>
      <li><strong>SENHA</strong> – criar uma senha para acessar o sistema;</li>
      <li>
        <strong>CONFIRMAR A SENHA</strong> – digitar a mesma senha informada em
        SENHA para garantir que está correta;
      </li>
      <li>
        <strong>Li e estou de acordo com os Termos de uso</strong> – são
        informações sobre os termos de uso do sistema de M & A na APS;
      </li>
      <li>
        <strong>Não sou um robô</strong> – essa opção evita que bots da internet
        tentem criar conta no sistema;
      </li>
    </ul>
    <p>
      Ao finalizar o preenchimento do formulário, você pode clicar em CADASTRAR
      (será mostrada uma mensagem de confirmação do cadastro). Para acessar o
      sistema, basta clicar em VOLTAR e informar CPF e SENHA cadastrados para
      entrar no seu acesso restrito.
    </p>
    <br />
    <p>
      O sistema não tem custo para o profissional de saúde, mas você precisa de
      autorização do gestor municipal para acessá-lo.
    </p>
    <h3>ATENÇÃO</h3>
    <p>
      Ao criar sua conta, faz-se necessário que o Administrador(a) municipal do
      e-SUS PEC ou Centralizador, Coordenador(a) ou Secretário(a) forneça
      autorização para seu acesso. A autorização de acesso pode ser realizada em
      <strong>INÍCIO >> Administração >> Gerenciar usuários</strong>. Essa é uma
      medida de segurança em conformidade com a Lei Geral de Proteção de dados
      (LGPD) para evitar acesso indevido aos dados.
    </p>
  </div>
</template>
<script>
export default {
  name: 'DocCadastro',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
